import initializeSkipToContent from '../Entries/skipToContentEntry';
import initializeRating from "../Entries/ratingEntry";
import initializeRatingMobile from "../Entries/ratingMobileEntry";
import initializeApplication from "../Entries/mainApplicationEntry";
import initializeApplicationHelper from '../Entries/helperEntry';
import initializeHotelOverview from "../Entries/hotelOverviewEntry";
import initializeGoogleMaps from "../Entries/googleMapsEntry";
import initializeUtilities from "../Entries/utilitiesEntry";
import initializeHotelCard from "../Entries/hotelCardEntry";
import initializeTabs from "../Entries/tabsEntry";
import initializeSunRating from "../Entries/sunRatingEntry";
import initializeHolidaycheck from "../Entries/holidaycheckEntry";
import initializeProgressBar from "Entries/progressBarEntry";
import initializeNavigation from "Entries/navigationEntry";
import initializeSearchMask from "Entries/searchMaskEntry";
import initializeHorizontalFilterBar from "Entries/filterBarHorizontalEntry";
import initializeOfferCard from "Entries/offerHotelCardEntry";
import initializeHotelDetailsBreadcrumb from "Entries/hotelDetailsBreadcrumbEntry";
import initializeFader from 'Entries/faderEntry';
import initializeBurgerMenu from "Entries/burgerMenuEntry";
import initializeCouponElements from "Entries/couponEntry";
import initializePRGLink from "../Entries/prgLinkEntry";
import initializeLturSocial from "../Entries/lturSocialEntry";
import Analytics from "Helper/Analytics";
import initializeLanguageSwitcherLinks from "../Entries/languageSwitcherEntry";
import initializeHotelGalleryUI from "Entries/hotelGalleryUIEntry";
import initializeHotelRatingContainer from "Entries/hotelRatingContainerEntry";
import initializeServiceWorkerDB from '../Entries/serviceWorkerDBEntry';
import initializeServiceWorker from "../Entries/serviceWorkerEntry";
import initializeHotelDetailBookmarkHeart from "../Entries/hotelDetailBookmarkHeartEntry";
import initializeHotelDetailRooms from "../Entries/hotelDetailsRoomsEntry";
import initializeDetailExpander from "Entries/detailExpanderEntry";
import initializeMoreReviews from "Entries/moreReviewsEntry";
var loginEntryPromise = import('../Entries/loginEntry');
document.addEventListener('DOMContentLoaded', function () {
    document.body.className += ' loaded';
    initializeLanguageSwitcherLinks();
    initializeApplication();
    initializeBurgerMenu();
    initializeNavigation();
    initializeRating();
    initializeRatingMobile();
    initializeSearchMask();
    initializeHorizontalFilterBar();
    initializeOfferCard();
    initializeHotelOverview();
    initializeHotelCard();
    initializeHotelDetailsBreadcrumb();
    initializeGoogleMaps();
    initializeUtilities();
    initializeTabs();
    initializeProgressBar();
    initializeSunRating();
    initializeHolidaycheck();
    initializeFader();
    initializeCouponElements();
    initializePRGLink();
    initializeLturSocial();
    initializeHotelRatingContainer();
    Analytics.bindTabClick();
    initializeServiceWorkerDB();
    initializeHotelDetailBookmarkHeart();
    initializeHotelDetailRooms();
    initializeDetailExpander();
    initializeMoreReviews();
    initializeSkipToContent('hoteldetail', 'onetrust-banner-sdk');
    loginEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
});
window.addEventListener('load', function () {
    initializeServiceWorker();
    initializeApplicationHelper();
    initializeHotelGalleryUI();
    initializeLanguageSwitcherLinks();
});
